import styled from 'styled-components/macro';
import FocusLock from 'react-focus-lock';
import ArrowDropDownIcon from 'assets/icons/arrow-dropdown';

export const NavDropDownStyled = styled.div`
  ${({ theme: { spacing } }) => `
    position: relative;
    height: 100%;
    padding: 0 ${spacing?.(0.5)};
  `}
`;

export const NavContainerStyled = styled(FocusLock)`
  height: 100%;
`;

export const NavDropDownLabel = styled.div`
  ${({ theme: { colors = {}, spacing, typography }, hasActiveChild }) => `
    ${typography?.(16)}
    border: 1px solid transparent;
    height: 100%;
    color: ${hasActiveChild ? colors.grey?.darkest : colors.primary?.default}};
    padding-left: ${spacing?.(1)};
    padding-right: ${spacing?.(1)};
    display: flex;
    align-items: center;
    font-weight: normal;

    ${
      hasActiveChild
        ? `box-shadow: inset 0px -3px 0px ${colors.primary?.default};`
        : ''
    }
    &:hover {
      cursor: pointer;
      background-color: ${colors.outline?.lighter};
    }
    &:focus {
      border: 1px dashed ${colors.primary?.default};
    }
    &:active {
      background-color: ${colors.primary?.lightest};
      border: 1px solid ${colors.primary?.default};
    }
  `}
`;

export const ArrowDropDownStyled = styled(ArrowDropDownIcon)`
  ${({ theme: { transitions, spacing }, open }) => `
    transform: ${open ? 'rotate(180deg)' : 'rotate(0)'};
    transition: all ${transitions?.fast} ease-in-out;
    margin-left: ${spacing?.(1)};
    margin-top: 0.2rem;
  `};
`;
